import { Component, OnInit } from '@angular/core';
import GeoJSON from 'ol/format/GeoJSON';

@Component({
  selector: 'lib-spatial-toolkit',
  templateUrl: './spatial-toolkit.component.html',
  styleUrls: ['./spatial-toolkit.component.scss'],
})
export class SpatialToolkitComponent implements OnInit {
  constructor() {}
  data;
  toggleDataEditor = true;
  clearMap: boolean = false;
  ngOnInit(): void {
    this.data = {
      type: 'FeatureCollection',
      crs: {
        type: 'name',
        properties: {
          name: 'EPSG:3857',
        },
      },
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [0, 0],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [
              [4e6, -2e6],
              [8e6, 2e6],
            ],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: [
              [4e6, 2e6],
              [8e6, -2e6],
            ],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [
              [
                [-5e6, -1e6],
                [-4e6, 1e6],
                [-3e6, -1e6],
              ],
            ],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'MultiLineString',
            coordinates: [
              [
                [-1e6, -7.5e5],
                [-1e6, 7.5e5],
              ],
              [
                [1e6, -7.5e5],
                [1e6, 7.5e5],
              ],
              [
                [-7.5e5, -1e6],
                [7.5e5, -1e6],
              ],
              [
                [-7.5e5, 1e6],
                [7.5e5, 1e6],
              ],
            ],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'MultiPolygon',
            coordinates: [
              [
                [
                  [-5e6, 6e6],
                  [-5e6, 8e6],
                  [-3e6, 8e6],
                  [-3e6, 6e6],
                ],
              ],
              [
                [
                  [-2e6, 6e6],
                  [-2e6, 8e6],
                  [0, 8e6],
                  [0, 6e6],
                ],
              ],
              [
                [
                  [1e6, 6e6],
                  [1e6, 8e6],
                  [3e6, 8e6],
                  [3e6, 6e6],
                ],
              ],
            ],
          },
        },
        {
          type: 'Feature',
          geometry: {
            type: 'GeometryCollection',
            geometries: [
              {
                type: 'LineString',
                coordinates: [
                  [-5e6, -5e6],
                  [0, -5e6],
                ],
              },
              {
                type: 'Point',
                coordinates: [4e6, -5e6],
              },
              {
                type: 'Polygon',
                coordinates: [
                  [
                    [1e6, -6e6],
                    [2e6, -4e6],
                    [3e6, -6e6],
                  ],
                ],
              },
            ],
          },
        },
      ],
    };
  }

  onGeojsonData(geojsonData) {
    this.data = geojsonData;
    this.clearMap = false;
  }

  onClearMap($event) {
    this.clearMap = $event;
    this.data = undefined;
  }
  toggleGeojsonViewer() {
    this.toggleDataEditor = !this.toggleDataEditor;
  }
}
